var AvatarComponent = /** @class */ (function () {
    function AvatarComponent() {
    }
    Object.defineProperty(AvatarComponent.prototype, "fullName", {
        set: function (data) {
            if (!data) {
                this.initials = "";
            }
            else {
                this.initials = data
                    .split(" ")
                    .map(function (name) { return name.charAt(0); })
                    .join("");
            }
        },
        enumerable: true,
        configurable: true
    });
    return AvatarComponent;
}());
export { AvatarComponent };
